<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M5.886 31.448L19.219 44.78c1.041 1.041 1.041 2.73 0 3.771-1.041 1.042-2.73 1.042-3.771 0L2.114 35.22c-1.041-1.041-1.041-2.73 0-3.771 1.042-1.042 2.73-1.042 3.772 0zm52.228-16c1.042-1.042 2.73-1.042 3.772 0 1.041 1.041 1.041 2.73 0 3.771L32.552 48.552c-1.041 1.042-2.73 1.042-3.771 0L15.448 35.22c-1.042-1.041-1.042-2.73 0-3.771 1.041-1.042 2.73-1.042 3.771 0l11.448 11.447zm-9.562 0c1.042 1.041 1.042 2.73 0 3.771L32.556 35.215c-1.042 1.042-2.73 1.042-3.771 0-1.042-1.041-1.042-2.73 0-3.77L44.78 15.447c1.041-1.042 2.73-1.042 3.771 0z" transform="translate(-210 -911) translate(210 911)"/>
            </g>
        </g>
    </g>
</svg>
